import "./Articles.scss";

import React from "react";
import { PageProps, graphql } from "gatsby";
import { useTranslation } from "react-i18next";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { SEOArguments } from "../classes/seoArguments";
import { LocalType } from "../models/localType";
import SEO from "../components/Seo";
import { BlogSingle } from "../components/listing/BlogSingle";
import MainLayout from "../components/layout/MainLayout";

export const query = graphql`
    query ArticlesTemplate {
        articles: allProductsJson(filter: { category: { eq: "/Century/CMS/Blog/" } }) {
            nodes {
                category
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                attributes {
                    blog_subject {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    content_short {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        metadata: allProductsJson(filter: { code: { eq: "century_trucs-astuces" } }) {
            nodes {
                code
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function Articles({ data }: PageProps<Queries.ArticlesTemplateQuery>) {
    const blogArticles = data.articles.nodes;
    const { t } = useTranslation("templatePages");
    const { currentLocale } = usePageLocalization();

    const seoArguments = new SEOArguments(data.metadata, currentLocale as keyof LocalType);

    return (
        <MainLayout>
            <SEO title={seoArguments.title} description={seoArguments.description} />
            <div className="container">
                <div className="row articles">
                    <div id="primary">
                        <h1 className="title">{t("articles-title")}</h1>
                        <div className="blogArticles">
                            {blogArticles.map((blogArticle: any) => {
                                return (
                                    <BlogSingle
                                        key={blogArticle.code}
                                        title={String(blogArticle?.title?.[currentLocale])}
                                        code={blogArticle?.code}
                                        content_short={
                                            blogArticle?.attributes?.content_short?.values?.[0][
                                                currentLocale
                                            ]
                                        }
                                        fields={blogArticle?.fields}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}
